import * as THREE from 'three'
import TWEEN from '@tweenjs/tween.js'
import Scene from './Scene'
import Model from '@/objects/Model'
import config from '@/config/selectCharacter'
import characters from '@/data/characters'
import store, { watch } from '@/store'

const rotationSpeed = 0.005
const step = -2 * Math.PI / characters.length

export default class SelectCharacterScene extends Scene {
  name = 'SelectCharacterScene'

  constructor (stage) {
    super()

    this.stage = stage
    this.environment = new THREE.Group()

    this.init()
  }

  init () {
    const geometry = new THREE.CircleGeometry(30, characters.length)
    geometry.rotateX(-Math.PI / 2)
    geometry.rotateY(-Math.PI / 2)
    geometry.translate(0, -2, 0)

    const getPosition = index => geometry.vertices[index + 1]

    characters.forEach(({ name }, index) => {
      const character = new Model(`/models/characters/${name}/static.glb`)
      character.name = name
      character.position.copy(getPosition(index))
      this.environment.add(character)
    })
  }

  goTo (action) {
    const direction = action === 'next' ? 1 : -1
    const target = this.environment.rotation.y + step * direction

    new TWEEN.Tween(this.environment.rotation)
      .to({ y: target }, 1000)
      .easing(TWEEN.Easing.Cubic.InOut)
      .start()
  }

  watchStore () {
    this.unwatch = watch('data', data => {
      if (store.state.scene === this.name) {
        this.goTo(data.action)
      }
    })
  }

  start () {
    const { background, fog } = config.scene
    const { from, to } = config.camera

    this.stage.add(this.environment)
    this.stage.followMouse = false

    this.stage.changeBackground(background, 1000)
    this.stage.changeFogColor(fog.color, 1000)
    this.stage.changeFogDistance(fog.near, fog.far, 1000)
    this.stage.setCameraPosition(from.x, from.y, from.z, 1000)
    this.stage.changeCameraPosition(to.x, to.y, to.z, 1000)

    this.watchStore()
  }

  stop () {
    this.unwatch && this.unwatch()
    this.stage.remove(this.environment)
    this.stage.followMouse = true
  }

  update () {
    const name = store.state.character
    const character = this.environment.children.find(child => child.name === name)
    if (character) character.rotation.y += rotationSpeed
  }
}
